import { useSearch } from "context/SearchContext";
import GuestsInput from "components/HeroSearchForm/GuestsInput";
import StayDatesRangeInput from "components/HeroSearchForm/StayDatesRangeInput";
import ButtonPrimary from "shared/Button/ButtonPrimary";


export interface StepProps {
  handleStepChange: () => void;
}
export const Step1: React.FC<StepProps> = ({ handleStepChange }) => {
  const {
    searchData,
    setSearchData,
    searchDestinations,
    getSearchPathWithQuery,
    myHotelInformation,
    handleSearch,
  } = useSearch();

  const getSearchLink = () => {
    if (
      searchDestinations.hotels.find((el) => el.slug === searchData.hotel_slug)
    ) {
      return getSearchPathWithQuery(
        "/booking-engine/listRooms/" + searchData.hotel_slug
      );
    } else if (myHotelInformation?.slug) {
      return getSearchPathWithQuery(
        "/booking-engine/listRooms/" + myHotelInformation?.slug
      );
    }
    return getSearchPathWithQuery(`/booking-engine/listRooms`);
  };

  const handleSearchClick = async () => {
    await handleSearch();
   
    window.history.replaceState(null, "Maison Kinko", getSearchLink());
    handleStepChange();
  };

  const renderSidebar = () => {
    return (
      <div className="flex justify-center">
        <div className="w-80 bg-white" style={{ maxHeight: "100vh" }}>
          <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 text-black">
            <StayDatesRangeInput
              defaultValue={searchData.dateRange}
              onChange={(e) => setSearchData({ ...searchData, dateRange: e })}
              wrapClassName="divide-x divide-neutral-200 dark:divide-neutral-700 !grid-cols-1 sm:!grid-cols-2"
              fieldClassName="p-3"
              anchorDirection={"right"}
              className=" flex-1"
            />
            <GuestsInput
              className="flex-1 border-y"
              fieldClassName="p-3"
              rooms={searchData.rooms}
              onChange={(e) => setSearchData({ ...searchData, rooms: e })}
              defaultValue={{}}
              hasButtonSubmit={false}
            />
        
          </form>
          <ButtonPrimary
            className="w-full text-sm !bg-[#aa8453] hover:!bg-[#222] rounded-none"
            onClick={handleSearchClick}
          >
            Rechercher
          </ButtonPrimary>
        </div>
      </div>
    );
  };

  return <div>{renderSidebar()}</div>;
};
